import { cn } from "@/utils/cn";

interface ActionButtonProps {
  label: string;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
  ariaLabel?: string;
  disabled?: boolean;
}

export default function ActionButton({
  label,
  onClick,
  className,
  ariaLabel,
  disabled,
}: ActionButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      className={cn(
        "font-semibold text-sm! border min-w-[80px] text-zinc-700 hover:text-zinc-900 hover:border-zinc-400 py-3 px-7 border-zinc-300 bg-white text-center rounded-full z-10 hover:opacity-90 transition-opacity",
        disabled && "opacity-50 cursor-not-allowed",
        className
      )}
    >
      {label}
    </button>
  );
}
